export default {
  users: (state) => state.users,
  roles: (state) => state.roles
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js